// ============================================
// FILE: src/components/fashion/SizeSelector.jsx
// ============================================

import React from 'react';
import { ChevronRight } from 'lucide-react';
import OptionDropdown from './OptionDropdown';

const SizeSelector = ({
  option,
  selectedValue = null,
  onChange = () => {},
  isAvailable = () => true,
  onOpenSizeGuide = null,
  highlight = false,
}) => {
  if (!option || !Array.isArray(option.values) || option.values.length === 0) {
    return null;
  }

  return (
    <div className={`mb-6 ${highlight ? 'ring-2 ring-[#ff3f6c] ring-offset-8 rounded' : ''}`}>
      <div className="flex items-center justify-between mb-3">
        <label className="fx-label" htmlFor={`option-${option.code}`}>Select {option.label}</label>
        {typeof onOpenSizeGuide === 'function' && (
          <button
            type="button"
            onClick={onOpenSizeGuide}
            className="flex items-center gap-0.5"
            style={{ color: 'var(--fx-pink)', fontSize: 14, fontWeight: 700 }}
          >
            Size Chart
            <ChevronRight size={15} />
          </button>
        )}
      </div>

      {/* A dropdown rather than a row of buttons; values that aren't
          available with the current selection stay listed but disabled. */}
      <OptionDropdown
        id={`option-${option.code}`}
        ariaLabel={`Select ${option.label}`}
        value={selectedValue}
        placeholder={`Select ${option.label.toLowerCase()}`}
        invalid={highlight}
        onChange={onChange}
        options={option.values.map((value) => {
          const available = isAvailable(value.value);
          return {
            value: value.value,
            label: available ? value.label : `${value.label} — out of stock`,
            disabled: !available,
          };
        })}
      />

      {highlight && (
        <p className="mt-2" style={{ color: 'var(--fx-pink)', fontSize: 13, fontWeight: 600 }}>
          Please select a {option.label.toLowerCase()}
        </p>
      )}
    </div>
  );
};

export default SizeSelector;
